import React from "react";
import { BaseLayout } from "../components/baseLayout";
import { Activity } from "../components/activity";

function Planning() {
  return (
    <BaseLayout>
      <div className="row mt-4">
        <div className="col-12">
          <div className="row">
            <Activity />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}

export { Planning };
